import type { ReactNode } from "react"

// Sharp, hairline section card with the mono eyebrow title. Section-level
// error strings from the API render inline in the header, so a degraded
// section is visible without hiding its neighbors.
export function SectionCard({
  title,
  error,
  children,
  right,
}: {
  title: string
  error?: string | null
  children: ReactNode
  right?: ReactNode
}) {
  return (
    <section className="border border-border bg-card">
      <header className="flex items-baseline justify-between gap-4 border-b border-border px-3 py-2">
        <h2 className="font-mono text-[10px] uppercase tracking-[0.14em] text-muted-foreground">
          {title}
        </h2>
        {right}
      </header>
      {error ? (
        <p
          className="px-3 pt-2 font-mono text-xs"
          style={{ color: "var(--viz-failed)" }}
        >
          {title} unavailable — {error}
        </p>
      ) : null}
      <div className="p-3">{children}</div>
    </section>
  )
}
